import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigationType } from "react-router-dom";
import { getFilterByKeyFromPage, getParamsFromFilterBy, isCuratorPage } from "../helpers/urlHelper";
import { getFilterValuesFromSearchQuery, setFilterValue, setFilterValueFromSearchQuery } from "../redux/slicers/admin/sidebarSlicer";
import { getFilterByFromQuery, getFilterOrderFromQuery, getMembersFromQuery, getSearchFromQuery, getSortByFromQuery, setFilterBy, setFilterByFromSearchQuery, setMembersFromSearchQuery, setParamsInSequence, setSearchFromSearchQuery, setSortByFromSearchQuery } from "../redux/slicers/filters/filterSlicer";
import { getGlobalSearchFromQuery, getTagsFromQuery, setSearchValueFromQuery, setTagsFromQuery } from "../redux/slicers/search/searchSlicer";
import { FILTER } from "../components/admin/curator/CuratorFilter/CuratorFilter";
import { removeDuplicateParams } from "../helpers/jsHelper";

export const SearchQueryFilterSync = () => {
  const dispatch = useDispatch();
  const navigationType = useNavigationType();
  const location = useLocation();

  useEffect(() => {
    // if (navigationType !== 'POP') return;

    // TODO: we might need to compare it to current state to avoid unnecessary data fetching
    const filterValues = getFilterValuesFromSearchQuery(location.search);
    dispatch(setFilterValueFromSearchQuery(filterValues));
    // console.log("filterValues: ", filterValues)

    // members
    const memberIds = getMembersFromQuery();
    const members = memberIds.map(id => ({ id }))
    dispatch(setMembersFromSearchQuery(members))

    // filterBy
    const filterBy = getFilterByFromQuery();
    dispatch(setFilterByFromSearchQuery(filterBy))
    // console.log("filterBy: ", filterBy)

    // sortBy
    const sortBy = getSortByFromQuery();
    dispatch(setSortByFromSearchQuery({ value: sortBy }))

    // search 
    const search = getSearchFromQuery();
    dispatch(setSearchFromSearchQuery(search || ''))

    // global search 
    const s = getGlobalSearchFromQuery();
    dispatch(setSearchValueFromQuery(s))

    // tags
    const tags = getTagsFromQuery();
    dispatch(setTagsFromQuery(tags))

    // filterOrder
    if(!isCuratorPage()) {
      let filterOrder = getFilterOrderFromQuery();

      if(!filterOrder.length){
        dispatch(setParamsInSequence([]));
        return;
      };

      filterOrder = filterOrder.map((a,i) => {
        const key = Object.keys(a)[0]

        if(key === 'filterBy') {
          return { [key]: getParamsFromFilterBy(filterBy, getFilterByKeyFromPage()) || undefined }
        } else if(key === 'tags') {
          return { [key]: tags.length ? tags : undefined }
        } else if(key === 'created_by') {
          return { [key]: memberIds.length ? memberIds : undefined }
        } else if(key === 'collections') {
          const collections = filterValues.filter(a => a.includes('collection_')).map(a => a.replace("collection_",""))
          return { [key]: collections.length ? collections : undefined }
        } else if(key === 'brands') {
          const brands = filterValues.filter(a => a.includes('brand_')).map(a => a.replace("brand_",""))
          return { [key]: brands.length ? brands : undefined }
        } else if(key === 'props') {
          const props = filterValues.filter(a => a.includes('prop_')).map(a => a.replace("prop_",""))
          return { [key]: props.length ? props : undefined }
        } else if(key.includes('fl_')) {

          const key_fl = Object.keys(filterOrder[i])[0]
          const key_opt = key.replace("fl_", "option_")
          const fl_val = filterValues.filter(a => a.includes(key_opt)).map(a => a.slice(a.lastIndexOf("_") + 1))

          return { [key_fl]: fl_val.length ? fl_val : undefined }
        } else if(key === 'is_favourite' && filterValues.includes("favourite")) {
          return { [key]: filterValues.includes("favourite") }
        } else if(key === 'is_prop_group' && filterValues.includes(FILTER.GROUP_PROP)) {
          return { [key]: filterValues.includes(FILTER.GROUP_PROP) }
        } else if(key === 'is_user_model_uploaded' && filterValues.includes(FILTER.USER_MODEL_UPLOADED)) {
          return { [key]: filterValues.includes(FILTER.USER_MODEL_UPLOADED) }
        } else if(key === 'assign_to_all_org' && filterValues.includes(FILTER.ALL_USER_PROPS)) {
          return { [key]: filterValues.includes(FILTER.ALL_USER_PROPS) }
        } else if(key === 'is_archive' && filterValues.includes("archive")) {
          return { [key]: filterValues.includes("archive") }
        } else if(key === 'is_mattress_material' && filterValues.includes(FILTER.MATTRESS_BUILDER)) {
          return { [key]: filterValues.includes(FILTER.MATTRESS_BUILDER) }
        } else {
          return { [key]: undefined }
        }

      }).filter(a => a[Object.keys(a)[0]] !== undefined)
       removeDuplicateParams(window.location?.href)
       dispatch(setParamsInSequence(filterOrder))
    }

  }, [location.search])

  return null;
} 